/**
 * Enumeration of all pages
 */
export enum Page {
    /** Represents the CanvasComponent */
    Canvas = "canvas",
    Login = "login",
    Register = "register",
};
